module.exports = __webpack_public_path__ + "img/slide9.5ebebe2d.png";